export const READY_MESSAGE_TYPE = "RC_READY";
export const AUTH_TOKEN_MESSAGE_TYPE = "RC_AUTH_TOKEN";
export const AUTH_FAILED_MESSAGE_TYPE = "RC_AUTH_FAILED";

export interface AuthTokenMessagePayload {
  token: string;
}

export const CHANGE_LANGUAGE_MESSAGE_TYPE = "CHANGE_LANGUAGE";

export interface ChangeLanguageMessagePayload {
  lang: "ar" | "en";
}
